import { render } from "./HelpModal.vue?vue&type=template&id=6befbdec&scoped=true&ts=true"
import script from "./HelpModal.vue?vue&type=script&lang=ts"
export * from "./HelpModal.vue?vue&type=script&lang=ts"

import "./HelpModal.vue?vue&type=style&index=0&id=6befbdec&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6befbdec"],['__file',"src/components/HelpModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6befbdec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6befbdec', __exports__)) {
    api.reload('6befbdec', __exports__)
  }
  
  module.hot.accept("./HelpModal.vue?vue&type=template&id=6befbdec&scoped=true&ts=true", () => {
    api.rerender('6befbdec', render)
  })

}


export default __exports__